import React from "react";
import { cn } from "@/lib/utils";
import { COUNTRIES } from "@/constants/map";

type CountryFlagLabelProps = {
  code?: string;
  name?: string;
  containerClassName?: string;
  flagClassName?: string;
  nameClassName?: string;
};

export const CountryFlagLabel: React.FC<CountryFlagLabelProps> = ({
  code,
  name,
  containerClassName,
  flagClassName,
  nameClassName
}) => {
  const displayName = React.useMemo(() => {
    const isoCandidate = (name || code)?.toUpperCase();
    if (!isoCandidate) return name;
    const match = COUNTRIES.find((country) => country.countryCode.toUpperCase() === isoCandidate);
    return match?.countryName ?? name;
  }, [name, code]);

  return (
    <div className={cn("flex items-center gap-2", containerClassName)}>
      {code ? (
        <span
          className={cn(
            "fi fis h-[16px] !w-[16px] rounded-full",
            `fi-${code.toLowerCase()}`,
            flagClassName
          )}
        ></span>
      ) : null}
      {name ? (
        <div className={cn("subtext-medium font-medium leading-6 text-foreground", nameClassName)}>
          {displayName}
        </div>
      ) : null}
    </div>
  );
};
